import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class CommunicationsNwsWeatherAlertsRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('communications-weather-alerts')) {
      void this.router.transitionTo('communications.message-log.new');
    }
  }
}
